import { activityFetch as fetch } from '../../components/feedback/requestActivity'
export const checkLabels = {
  readiness: '준비검사와 정상 종료', capacity: '병행 기동에 필요한 여유 용량',
  database: '구·신 버전 DB 스키마 호환', state: '로그인 세션·업로드 파일 유지',
  jobs: '예약 작업·큐 중복 처리 방지', routing: '진입 경로 전환·버전별 지표',
}
export const missingLabels = { ...checkLabels, currentTarget: '현재 실행 대상', rollbackTarget: '복구 대상',
  namespace: '네임스페이스', workload: '워크로드 이름', image: '검증할 이미지 digest' }
export function newPlan() {
  return { version: 1, displayName: '', serviceId: '', environment: 'production', mode: 'migration',
    strategy: 'bluegreen', currentTarget: '', rollbackTarget: '', namespace: 'antsnest', workload: '', image: '',
    replicas: 2, observeMinutes: 10, errorPercent: 1, latencyMs: 500, minRequests: 100,
    drainSeconds: 60, checks: Object.fromEntries(Object.keys(checkLabels).map(key => [key, false])) }
}
export function timeline(plan, step, failed) {
  const rolling = plan.strategy === 'rolling'
  const phases = rolling ? ['현재 버전', '새 파드 준비', '점진 교체', '새 버전 관찰', '교체 완료']
    : plan.strategy === 'canary' ? ['기동·검사', '5% 검증', '25% 검증', '50% 검증', '100% 승격']
      : ['병행 기동', '업무 검증', '트래픽 전환', '관찰', '복구 지점 보존']
  const replicas = Number.isInteger(plan.replicas) && plan.replicas >= 2 ? plan.replicas : 2
  const share = plan.strategy === 'canary' ? [0, 5, 25, 50, 100][step] : step < 2 ? 0 : 100
  const oldPods = step < 2 ? replicas : step === 2 ? replicas - 1 : 0
  const newPods = step === 0 ? 0 : step === 1 ? 1 : step === 2 ? 2 : replicas
  return { phases, old: failed ? (rolling ? `${replicas}개` : '100%') : rolling ? `${oldPods}개` : `${100 - share}%`,
    next: failed ? (rolling ? '복구 대기' : '0%') : rolling ? `${newPods}개` : `${share}%`,
    caption: failed ? '승격 중지 → 이전 경로·릴리스 복구 → 업무 재검사'
      : rolling ? 'maxUnavailable 0 · maxSurge 1 · 준비된 파드부터 교체'
        : '기존 연결을 배출하며 검증한 새 경로로 전환',
    peak: plan.mode === 'migration' ? `기존 PM2 유지 + 새 파드 ${replicas}개`
      : `최대 ${rolling ? replicas + 1 : replicas * 2}개 파드의 용량 확인` }
}

export async function planApi(path, options = {}) {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token')
  const response = await fetch(`/api/deploy${path}`, { ...options, credentials: 'include',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}) } })
  let body
  try { body = await response.json() } catch { throw Error('서버 응답을 읽을 수 없습니다. 입력은 유지됩니다.') }
  if (!response.ok) throw Error(({
    LOGIN_REQUIRED: '로그인이 필요합니다.', INVALID_SESSION: '로그인이 만료됐습니다. 다시 로그인해 주세요.',
    ADMIN_REQUIRED: '관리자 권한이 필요합니다.', AUTH_UNAVAILABLE: '관리자 권한을 확인할 수 없습니다.',
    RELEASE_PLAN_UNAVAILABLE: '배포 계획 저장소에 연결할 수 없습니다. 입력은 유지됩니다.',
    RELEASE_PLAN_REVISION_CONFLICT: '다른 곳에서 이 계획이 수정됐습니다. 입력을 내보내 보관한 뒤 최신 계획을 불러오세요.',
    INVALID_RELEASE_PLAN: '계획 이름·대상 형식·숫자 범위를 확인해 주세요. 이미지는 sha256 digest로 지정합니다.',
  })[body.code] || '요청을 처리하지 못했습니다. 입력은 유지됩니다.')
  return body
}
